import validate from 'validate.js';
import isEmpty from 'lodash/isEmpty';

export const validateFormFields = (fields: any) => isEmpty(fields);

export const formsAreValidated = (formsValidation: any) => {
  return isEmpty(Object.values(formsValidation).filter(form => form));
};

export const listOfFormsAreValidated = (formsValidation: any) => {
  const notValidatedForms = formsValidation.filter((form: any) => {
    return !isEmpty(form) && form;
  });
  return notValidatedForms.length === 0;
};

validate.validators.presence.options = {
  message: { id: 'validate.required_field' },
  allowEmpty: false,
};
export const displayErrorText = (fields: any, message: any) => {
  const error = fields;
  return { error, message };
};

export default validate;
